import React from 'react'
import Navbar from '../Components/Navbar'
import Sidebar from '../Components/Sidebar'
import '../Layouts/Sidebarlayout.css'
import { connect } from 'react-redux'
import { sidebarOpen } from '../Services/Sidebar/action'

const Sidebarlayout = (props) => {
  const menuCollapse = props.menuCollapse;

  const menuIconClick = () => {
    props.sidebarOpen();
  };

  return (
    <div>
      <div className={`${menuCollapse ? "main sidebar-closed" : "main"}`}>
        <div className={`header-backdrop ${!menuCollapse ? 'body-overlay' : ''}`}
        onClick={menuIconClick}></div>
        <div className={`header ${menuCollapse ? "header-closed" : ""}`}>
          <Navbar />
        </div>
        <div className="sidebar">
          <Sidebar menuCollapse={menuCollapse} menuIconClick={menuIconClick} />
        </div>
        <div className={`content ${menuCollapse ? 'content-closed' : ''}`}>
          {props.children}
        </div>
      </div>
    </div>
  )
}

export const mapStateToProps = (state) => {
  return {
    menuCollapse: state.sidebarReducer.isOpen,
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    sidebarOpen: () => {
      dispatch(sidebarOpen())
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Sidebarlayout)
